export default {
    sendPasswordMail: 'Send password e-mail directly',
    next: 'Import {cnt}|Import {cnt} users',
    back: 'Back',
    items: {
        salutation: {
            mr: 'Mr',
            mrs: 'Mrs'
        },
        locked: {
            y: 'yes',
            n: 'no'
        }
    }
}
